import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-chart-fullscreen',
  templateUrl: './chart-fullscreen.component.html',
  styleUrls: ['./chart-fullscreen.component.scss']
})
export class ChartFullscreenComponent implements OnInit {

  constructor(
    public dialgoRef: MatDialogRef<ChartFullscreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    this.loadData();
  }

  loadData(){
    const datata = this.data;
    this.data = null;
    setTimeout(()=>{
      this.data = datata;
    },500)
  }

}
